import { motion } from "framer-motion";
import { CONTACT_INFO } from "../data/content";

/**
 * Floating WhatsApp CTA button (bottom-right, fixed).
 * Number is configured in /app/frontend/src/data/content.js → CONTACT_INFO.whatsapp
 * If empty/placeholder, gracefully redirects to /contact page.
 */
export const WhatsAppButton = () => {
  const number = (CONTACT_INFO.whatsapp || "").replace(/\D/g, "");
  const href = number
    ? `https://wa.me/${number}?text=${encodeURIComponent(
        "Hi OBSIDIAN MEDIA — I'd like to discuss a project."
      )}`
    : "/contact";
  const isPlaceholder = !number;

  return (
    <motion.a
      href={href}
      target={isPlaceholder ? "_self" : "_blank"}
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.5, type: "spring", stiffness: 220 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="group fixed z-40 bottom-20 right-6 md:bottom-8 md:right-8 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center bg-gradient-to-br from-[#25D366] to-[#128C7E] shadow-[0_10px_40px_rgba(37,211,102,0.45)] border border-white/10"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" style={{ animationDuration: "2.4s" }} />
      <svg
        viewBox="0 0 32 32"
        className="relative w-7 h-7 md:w-8 md:h-8 text-white"
        fill="currentColor"
        aria-hidden
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.65-.474 2.65-1.682 0-.073 0-.15-.014-.215-.187-.363-1.18-.572-1.621-.815zm-3.034 7.066c-1.39 0-2.78-.327-4.039-.96l-2.836.788.749-2.722a8.7 8.7 0 0 1-1.346-4.673c0-4.95 4.066-8.96 9.022-8.96 4.957 0 9.022 4.01 9.022 8.96s-4.065 8.967-8.572 8.967zm0-19.733c-5.812 0-10.51 4.69-10.51 10.487 0 1.794.487 3.555 1.418 5.122l-1.502 5.428 5.7-1.488a10.46 10.46 0 0 0 4.894 1.232h.014c5.812 0 10.844-4.673 10.844-10.487 0-2.78-1.246-5.42-3.193-7.4a10.39 10.39 0 0 0-7.665-2.894z" />
      </svg>

      {/* Hover label */}
      <span className="absolute right-full mr-3 hidden md:block whitespace-nowrap bg-black border border-white/10 px-3 py-2 text-[10px] uppercase tracking-[0.25em] text-white opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
